const EIMSMASK = 1;
const TENANTBILLINGMASK = 2;
const UTILITYBILLMASK = 4;
const WELLSTATMASK = 8;

const NUMBER_SUFFIXES = [
  "th",
  "st",
  "nd",
  "rd",
  "th",
  "th",
  "th",
  "th",
  "th",
  "th",
];

export const getDatapoint = ({ datapoints, datapointId }) => {
  if (!datapoints) return;

  for (const [, dps] of Object.entries(datapoints)) {
    if (!Array.isArray(dps)) {
      continue;
    }
    const dp = dps.find((it) => it.datapoint_id === datapointId);
    if (dp) return dp;
  }
};

export const getNextKey = (tag, prefix) => {
  const r = `${prefix}_${crypto.randomUUID()}`;
  return r;
};

export const ordinal = (i) => {
  switch (i % 100) {
    case 11:
    case 12:
    case 13:
      return `${i}th`;
    default:
      return `${i}${NUMBER_SUFFIXES[i % 10]}`;
  }
};

export const checkPermissions = (options) => {
  let ret = false;
  switch (options.applicationName) {
    case "EIMS":
      if ((options.products & EIMSMASK) === EIMSMASK) ret = true;
      break;
    case "TENANTBILLING":
      if ((options.products & TENANTBILLINGMASK) === TENANTBILLINGMASK) {
        ret = true;
      }
      break;
    case "UTILITYBILLS":
      if ((options.products & UTILITYBILLMASK) === UTILITYBILLMASK) ret = true;
      break;
    case "WELLSTAT":
      if ((options.products & WELLSTATMASK) === WELLSTATMASK) ret = true;
      break;
    case "NOOP":
      ret = true;
      break;
    default:
      ret = false;
      break;
  }
  return ret;
};

export const formatDate = (indate) => {
  const year = indate.getFullYear();
  const month = `0${indate.getMonth() + 1}`.slice(-2);
  const date = `0${indate.getDate()}`.slice(-2);

  return `${year}-${month}-${date}`;
};

export const formatDateSlashes = (indate) => {
  const year = indate.getFullYear();
  const month = `0${indate.getMonth() + 1}`.slice(-2);
  const date = `0${indate.getDate()}`.slice(-2);

  return `${year}/${month}/${date}`;
};

export const formatDateRange = (range) => {
  return `${formatDate(range[0])} - ${formatDate(range[1])}`;
};

export const formatDateRangeSlashes = (range) => {
  return `${formatDateSlashes(range[0])} - ${formatDateSlashes(range[1])}`;
};

export const formatDateUTC = (indate) => {
  const year = indate.getUTCFullYear();
  const month = `0${indate.getUTCMonth() + 1}`.slice(-2);
  const date = `0${indate.getUTCDate()}`.slice(-2);

  return `${year}-${month}-${date}`;
};

export const formatDateHourMinutesUTC = (indate) => {
  const year = indate.getUTCFullYear();
  const month = `0${indate.getUTCMonth() + 1}`.slice(-2);
  const date = `0${indate.getUTCDate()}`.slice(-2);
  const hour = `0${indate.getUTCHours()}`.slice(-2);
  const minute = `0${indate.getUTCMinutes()}`.slice(-2);

  return `${year}-${month}-${date} ${hour}:${minute}`;
};

export const formatDateHourMinutes = (d) => {
  const year = d.getFullYear();
  const month = `0${d.getMonth() + 1}`.slice(-2);
  const date = `0${d.getDate()}`.slice(-2);
  const hour = `0${d.getHours()}`.slice(-2);
  const minute = `0${d.getMinutes()}`.slice(-2);
  return `${year}-${month}-${date} ${hour}:${minute}`;
};

export const formatDateTime = (indate) => {
  const year = indate.getFullYear();
  const month = `0${indate.getMonth() + 1}`.slice(-2);
  const date = `0${indate.getDate()}`.slice(-2);
  const hour = `0${indate.getHours()}`.slice(-2);
  const minute = `0${indate.getMinutes()}`.slice(-2);
  const seconds = `0${indate.getSeconds()}`.slice(-2);
  return `${year}-${month}-${date}T${hour}:${minute}:${seconds}`;
};

export const formatTime = (d) => {
  return d ? formatDateTime(d).split("T")[1] : undefined;
};

export const prettyDateTime = (indate) => {
  if (typeof indate === Date) {
    return formatDateTime(indate).replace("T", " ");
  }
  return formatDateTime(new Date(indate)).replace("T", " ");
};

export const parseDateTime = (s) =>
  new Date(Date.parse(s.replaceAll(/\s/g, "T")));

export const parseDate = (s) => parseDateTime(`${s}T00:00:00`);

export const startOfDay = (date) => {
  const d = new Date(date.getTime());
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d;
};

export const addDays = (date, days) => {
  const d = new Date(date.getTime());
  d.setDate(d.getDate() + days);

  return d;
};

export const daysInRange = (start, end) => {
  const days = [];
  for (
    let d = new Date(start.getTime());
    d.getTime() <= end.getTime();
    d = addDays(d, 1)
  ) {
    days.push(d);
  }
  return days;
};

export const calcDaysInRange = (start, end) => {
  const s = new Date(Math.min(start.getTime(), end.getTime()));
  const e = new Date(Math.max(start.getTime(), end.getTime()));

  return daysInRange(s, e).length;
};

export const endOfDay = (date) => {
  const d = new Date(date.getTime());
  d.setHours(23);
  d.setMinutes(59);
  d.setSeconds(59);
  d.setMilliseconds(999);
  return d;
};

export const dateBackDays = (days) => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return startOfDay(d);
};

export const today = () => {
  return dateBackDays(0);
};

export const yesterday = () => {
  return dateBackDays(1);
};

const TODAY = "Today";
const YESTERDAY = "Yest";
const ONE_WEEK = "1W";
const ONE_MONTH = "1M";
const THREE_MONTHS = "3M";
const SIX_MONTHS = "6M";
const ONE_YEAR = "1Y";

export const TODAY_RANGE = [today(), today()];
export const ONE_WEEK_RANGE = [dateBackDays(6), today()];

export const calcDateRange = (filter) => {
  switch (filter) {
    case TODAY:
      return TODAY_RANGE;
    case YESTERDAY:
      return [yesterday(), yesterday()];
    case ONE_WEEK:
      return ONE_WEEK_RANGE;
    case ONE_MONTH:
      return [dateBackDays(30), today()];
    case THREE_MONTHS:
      return [dateBackDays(90), today()];
    case SIX_MONTHS:
      return [dateBackDays(182), today()];
    case ONE_YEAR:
      return [dateBackDays(365), today()];
    default:
      // should NEVER happen
      return TODAY_RANGE;
  }
};

export const getDateRanges = () => {
  return [
    TODAY,
    YESTERDAY,
    ONE_WEEK,
    ONE_MONTH,
    THREE_MONTHS,
    SIX_MONTHS,
    ONE_YEAR,
  ].map((it) => ({
    name: it,
    range: () => calcDateRange(it),
  }));
};

export const formatNumber = (num, minPrecision, maxPrecision) => {
  return parseFloat(num).toLocaleString(undefined, {
    minimumFractionDigits: minPrecision,
    maximumFractionDigits: maxPrecision,
    useGrouping: true,
  });
};

export const formatKw = (num) => {
  return formatNumber(num, 1, 1);
};

export const formatMlbs = (num) => {
  return formatNumber(num, 2, 2);
};

export const getLatestValue = (intervals) => {
  try {
    let xindex = -1;
    let offsetfactor = 288;
    if (intervals.length >= 96) offsetfactor = 96; // 15 minute data
    if (intervals.length >= 288) offsetfactor = 288; // 5 minute data

    const val = intervals.reverse().find((x, index) => {
      xindex = offsetfactor - index;
      return x !== null && x !== undefined;
    });
    return [val, xindex];
  } catch (e) {
    return "";
  }
};

export const floorDisplay = (floor) => {
  const floorInt = parseInt(floor);
  return isNaN(floorInt) ? `Floor ${floor}` : `${ordinal(floorInt)} Floor`;
};

export const roundToSingleDecimalPlace = (value) => {
  return Math.round(value * 10) / 10;
};

export const roundToTwoDecimalPlaces = (value) => {
  return Math.round(value * 100) / 100;
};

export const formatFileSize = (sizeInBytes) => {
  const KB = 1000;
  const MB = 1000 * KB;
  if (sizeInBytes >= MB) {
    return `${(sizeInBytes / MB).toFixed(2)} MB`;
  } else if (sizeInBytes >= KB) {
    return `${(sizeInBytes / KB).toFixed(2)} KB`;
  } else {
    return `${sizeInBytes} bytes`;
  }
};
